import { __assign, __rest } from "tslib";
import React from 'react';
import { twMerge } from 'tailwind-merge';
export var FieldError = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("p", __assign({}, rest, { className: twMerge('text-error-accent flex items-center', className) }), children));
};
export default FieldError;
